import { ComponentProps } from 'react';

export function MessageCheck({ ...props }: ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5125 8.525L14.5687 14.2937L12.7125 12.4375C12.1266 11.8516 11.1775 11.8516 10.5912 12.4375C10.005 13.0234 10.0053 13.9725 10.5912 14.5588L13.5912 17.5588C13.8725 17.84 14.255 17.9982 14.6519 17.9982C14.6714 17.9982 14.6909 17.9982 14.7085 17.9962C15.125 17.9813 15.5187 17.7938 15.7875 17.475L21.7875 10.475C22.3266 9.84625 22.2543 8.89875 21.6254 8.36C21 7.825 20.05 7.89375 19.5125 8.525ZM28 0H4C1.79688 0 0 1.79688 0 3.94375V21.8875C0 24.0906 1.79688 25.8312 4 25.8312H10V31.025C10 31.6397 10.6887 31.9969 11.195 31.6313L19.0012 25.775H28.0012C30.2044 25.775 32.0013 23.9781 32.0013 21.8312V3.94375C32 1.79688 30.2563 0 28 0ZM29.0562 22C29.0562 22.5469 28.6031 23 28.0562 23H18.0562L13.0562 26.75V23H4.05625C3.50938 23 3.05625 22.5469 3.05625 22V4C3.05625 3.45312 3.50938 3 4.05625 3H28.0562C28.6031 3 29.0562 3.45312 29.0562 4V22Z"
        fill="currentColor"
      />
    </svg>
  );
}
